<script setup lang="ts">
import { DeviceInformationDto } from '@/api/generator';
import { mdiLinkVariant } from '@mdi/js';
import { computed } from 'vue';
import { connectedArrayInfoOf } from './utils/deviceInformation';

const props = defineProps<{
  value?: DeviceInformationDto | null;
}>();

const array = computed(() => connectedArrayInfoOf(props.value));
const label = computed(() =>
  array.value?.serialNumber
    ? `${array.value.name} | ${array.value.serialNumber}`
    : array.value?.name,
);
</script>

<template>
  <div v-if="array" class="device-connected-array d-flex align-center">
    <v-icon size="16">{{ mdiLinkVariant }}</v-icon>
    <div>{{ label }}</div>
  </div>
</template>

<style lang="scss" scoped>
.device-connected-array {
  padding: 2px;
  gap: 4px;
}
</style>
